import { useState, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Button from '@components/Button';
import { Typography } from '@components/Typography';
import Avatar from '@components/Avatar';
import { getInitialsFull } from '@helpers/userName';
import { UserIcon } from 'assets/images/icons';

const StyledAvatar = styled(Avatar)({
    fontSize: '12px',
    marginRight: '10px',
});

const StyledArrow = styled(ArrowDropDownIcon)({
    height: 32,
    '& path': {
        fill: 'rgba(0, 0, 0, 0.87)',
    },
});

const StyledUserIcon = styled(UserIcon)({
    width: '12px !important',
    height: '12px !important',
    '& path': {
        fill: 'rgba(0, 0, 0, 0.38)',
        fillOpacity: 1,
    },
});

const UsersMenu = ({ value, options, onSelect }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const selectedOption = useMemo(() => options.find(user => user.value === value), [options, value]);

    const onClick = event => setAnchorEl(event.currentTarget);

    const onClose = () => setAnchorEl(null);

    return (
        <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginRight: '8px' }}>
            <Button variant="text" onClick={onClick} sx={{ padding: 0, minWidth: '20px', borderRadius: '45px' }}>
                <Avatar
                    size="medium"
                    fullName={selectedOption?.label}
                    label={getInitialsFull(selectedOption?.label)}
                    icon={<StyledUserIcon />}
                />
            </Button>
            <StyledArrow size="small" onClick={onClick} />
            <Menu
                id="users-menu"
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={onClose}
                sx={{
                    '.MuiMenu-paper': {
                        borderRadius: '4px',
                    },
                }}
            >
                {options.map(user => (
                    <MenuItem
                        key={user.value}
                        onClick={() => {
                            onSelect(user.value);
                            onClose();
                        }}
                        selected={user.value === value}
                        sx={{
                            '&.Mui-selected': {
                                backgroundColor: '#E4EAEB !important',
                            },
                        }}
                    >
                        <StyledAvatar size="small" fullName={user.label} label={getInitialsFull(user.label)} />
                        <Typography variant="body2">{user.label}</Typography>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default UsersMenu;
